import Box from '@mui/material/Box/Box';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography/Typography';
import { colors, devices } from 'styles';

export const ArrowWrapper = styled(Box)`
  position: absolute;
  left: 50%;
  transform: translate(-50%);
  bottom: 0px;
`;

export const FirstSectionWrapper = styled(Box)`
  display: flex;
  justify-content: inherit;
  width: 100%;
  flex-direction: column;

  @media (${devices.sm}) {
    flex-direction: row;
    justify-content: space-between;
    gap: 60px;
  }
`;

export const FirstSectionTitle = styled(Typography)`
  font-weight: 700;
  font-size: 24px;
  line-height: 120%;
  color: ${colors.white};
  max-width: 100%;
  margin-right: 0px;
  margin-bottom: 80px;
  width: 100%;

  @media (${devices.sm}) {
    margin-bottom: 0px;

    max-width: 353px;
  }

  @media (${devices.md}) {
    margin-right: 60px;
    font-size: 36px;
    max-width: 560px;
  }
`;

export const FirstSectionDescription = styled(Typography)`
  font-size: 18px;
  line-height: 150%;
  color: ${colors.white};
  max-width: 100%;

  @media (${devices.sm}) {
    max-width: 353px;
  }

  @media (${devices.md}) {
    max-width: 560px;
  }
`;

export const ItemsWrapper = styled(Box)`
  margin-top: 80px;
  display: flex;
  justify-content: inherit;
  width: 100%;
  flex-direction: column;

  @media (${devices.sm}) {
    flex-direction: row;
    justify-content: space-between;
  }
`;

export const ItemWrapper = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'itemsCount',
})<{ itemsCount: number }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  max-width: 343px;
  margin-bottom: 40px;
  color: ${colors.white};

  @media (${devices.sm}) {
    max-width: 168px;
    margin-bottom: 0px;
  }

  @media (${devices.md}) {
    max-width: 250px;
    margin-bottom: 0px;
  }

  @media (${devices.lg}) {
    max-width: ${({ itemsCount }) => (itemsCount === 4 ? '250px' : '360px')};
  }
`;
